export default __webpack_public_path__ + "static/media/alert.17ae92c5.svg";